module.exports = __webpack_public_path__ + "img/bg02_zhTc.4594c31d.png";